import { API, Auth } from 'aws-amplify';
import awsconfig from './aws-exports';

API.configure(awsconfig);

export const getToken = async () => {

    const user = await Auth.currentAuthenticatedUser();
    const token = user.signInUserSession.idToken.jwtToken;

    //console.log({token});
    //console.log({user});

    return token;
}



export const subscribe = async (subscriber, channel) => {
    try {
        await API.post('scgapi', '/subscribers', {
            body: {
                subscriber: subscriber,
                channel: channel
            }
        })
    } catch (e) {
        console.log("oh noes", e)
    }
}

export const subscriberreport = async () => {

    try {
        const token = await getToken();
        const requestInfo = {
            headers: {
                Authorization: token,
            }
        }

        const data = await API.get('scgapi', '/subscriberreport', requestInfo)

        return data;
    } catch (e) {
        console.log("oh noes", e)
    }

}

//emailsubject, textpart, htmlpart, smstextpart, incidentstatus, incidentid, started_at
export const sendalerts = async (payload) => {

    try {

        const token = await getToken();
        const requestInfo = {
            headers: {
                Authorization: token,
            },
            body: {
                payload: payload
            }
        }

        const response = await API.post('scgapi', '/sendalerts', requestInfo)

        return response;
    } catch (e) {
        console.log("oh noes", e)
    }

}


export const alertshistory = async () => {

    try {
        const data = await API.get('scgapi', '/alertshistory')

        return data;
    } catch (e) {
        console.log("oh noes", e)
    }

}

export const incidenthistory = async () => {

    try {
        const data = await API.get('scgapi', '/incident')

        return data;
    } catch (e) {
        console.log("oh noes", e)
    }

}

export const alertstemplate = async () => {

    try {
        const token = await getToken();
        const requestInfo = {
            headers: {
                Authorization: token,
            }
        }

        const data = await API.get('scgapi', '/template', requestInfo)

        return data;
    } catch (e) {
        console.log("oh noes", e)
    }

}